const checkMissingData = (missingFieldName) => {
  if (!missingFieldName || missingFieldName?.length) {
    return true;
  } else {
    return false
  }
}

export default checkMissingData